import LeaderboardMetricFieldName from "@mapmycustomers/shared/enum/fieldModel/LeaderboardMetricFieldName";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import { METRIC_TO_ENTITY_TYPE } from "@app/scene/dashboard/store/const";
import { isCustomField } from "@app/util/fieldModel/impl/assert";

const getRankingMetricEntityType = (rankingMetric: IField) => {
  return isCustomField(rankingMetric)
    ? rankingMetric.customFieldData.entity
    : METRIC_TO_ENTITY_TYPE[rankingMetric.name as LeaderboardMetricFieldName];
};

export default getRankingMetricEntityType;
